import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { stdSliceSelectors } from './data/aiMemories/aiMemoriesSelectors';
import { aiMemoriesActions } from './data/aiMemories/aiMemoriesSlice';

import { useAppDispatch, useAppSelector } from 'hooks/redux';

import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';
import { v4 as uuidv4 } from 'uuid';

const ConfirmDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>Are you sure you want to delete all memories?</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          Cancel
        </Button>
        <Button onClick={onConfirm} color='secondary'>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

const ManageMemories = ({ open, onClose }) => {
  const theme = useTheme();
  const [newMemory, setNewMemory] = useState('');
  const [confirmOpen, setConfirmOpen] = useState(false);

  const userMemories = useAppSelector(stdSliceSelectors.selectAll);
  const dispatch = useAppDispatch();

  const handleAddMemory = () => {
    if (newMemory.trim().length > 5) {
      dispatch(
        aiMemoriesActions.create({
          clientId: uuidv4().toUpperCase(),
          data: {
            name: '',
            memory: newMemory.trim(),
            priority: 0,
          },
        }),
      );
      setNewMemory('');
    }
  };

  const handleDeleteMemory = (id) => {
    if (id) dispatch(aiMemoriesActions.delete(id));
  };

  const handleDeleteAllMemories = () => {
    setConfirmOpen(true);
  };

  const handleConfirmDeleteAll = () => {
    // Deleting the entire store
    userMemories.forEach((p, index) => {
      setTimeout(() => {
        if (p && p.id) dispatch(aiMemoriesActions.delete(p?.id));
      }, 100 * index);
    });
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
        <DialogTitle>Manage Memories</DialogTitle>
        <DialogContent>
          <Box style={{ marginTop: theme.spacing(2) }} display='flex' alignItems='center' gap={2} mb={2}>
            <TextField
              fullWidth
              label='Add a new memory'
              value={newMemory}
              onChange={(e) => setNewMemory(e.target.value)}
            />
            <Button variant='contained' onClick={handleAddMemory}>
              Add
            </Button>
          </Box>
          <List style={{ maxHeight: '300px', overflow: 'auto' }}>
            {userMemories.map((memObj, index) => (
              <ListItem
                key={index}
                secondaryAction={
                  <IconButton edge='end' aria-label='delete' onClick={() => handleDeleteMemory(memObj.id)}>
                    <DeleteIcon style={{ color: theme.palette.error.dark }} />
                  </IconButton>
                }
              >
                <ListItemText primary={memObj.data.memory} />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteAllMemories} color='secondary'>
            Delete All
          </Button>
          <Button onClick={onClose} color='primary'>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmDialog open={confirmOpen} onClose={() => setConfirmOpen(false)} onConfirm={handleConfirmDeleteAll} />
    </>
  );
};

ManageMemories.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ManageMemories;
